var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTenancy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3299 3.65L11.0599 0.27C10.3999 -0.09 9.59987 -0.09 8.93987 0.27L2.66987 3.65C2.20987 3.9 1.92987 4.38 1.92987 4.93C1.92987 5.47 2.20987 5.96 2.66987 6.21L8.93987 9.59C9.26987 9.77 9.63987 9.86 9.99987 9.86C10.3599 9.86 10.7299 9.77 11.0599 9.59L17.3299 6.21C17.7899 5.96 18.0699 5.48 18.0699 4.93C18.0699 4.38 17.7899 3.9 17.3299 3.65Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91 10.76L2.07 7.83997C1.62 7.61997 1.1 7.63997 0.68 7.89997C0.25 8.16997 0 8.61997 0 9.11997V14.63C0 15.58 0.53 16.44 1.38 16.87L7.21 19.79C7.41 19.89 7.63 19.94 7.85 19.94C8.11 19.94 8.37 19.87 8.6 19.73C9.03 19.47 9.28 19.01 9.28 18.51V13C9.29 12.04 8.76 11.18 7.91 10.76Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.32 7.89999C18.89 7.63999 18.37 7.60999 17.93 7.83999L12.1 10.76C11.25 11.19 10.72 12.04 10.72 13V18.51C10.72 19.01 10.97 19.47 11.4 19.73C11.63 19.87 11.89 19.94 12.15 19.94C12.37 19.94 12.59 19.89 12.79 19.79L18.62 16.87C19.47 16.44 20 15.59 20 14.63V9.11999C20 8.61999 19.75 8.16999 19.32 7.89999Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTenancy);
export default __webpack_public_path__ + "static/media/tenancy.38a70cbff57ab89b2c0ad4856d21a0c3.svg";
export { ForwardRef as ReactComponent };